import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "detailsContent"]

  connect() {
    // Initial setup
  }

  showDetails(event) {
    const dateStr = event.currentTarget.dataset.date
    const content = event.currentTarget.dataset.detailsContent

    if (content && this.hasDetailsTarget) {
      this.detailsContentTarget.innerHTML = content
      this.detailsTarget.classList.remove("hidden")
    }
  }

  hideDetails() {
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.add("hidden")
    }
  }
}
